








import { Component, Watch, Vue } from 'vue-property-decorator';
import { gsap } from 'gsap';

@Component
export default class CurrentEventPanel extends Vue {
  get currentEvent() {
    return this.$store.getters['events/getCurrentEvent'];
  }

  get minimized() {
    return this.$store.getters['settings/getMinimized'];
  }

  configBg = {
    x: 0,
    y: 0,
    width: Math.min(window.innerWidth * 0.9, 400),
    height: 270,
    cornerRadius: 20,
    fill: '#f4f4f4',
    stroke: '#aeaeae',
    strokeWidth: 1,
  };

  configEventPanel = {
    x: window.innerWidth / 2 - this.configBg.width / 2,
    y: window.innerHeight,
  };

  configImage = {
    x: (this.configBg.width * 0.4) / 2,
    y: -40,
    width: this.configBg.width * 0.6,
    height: 80,
    cornerRadius: 20,
    stroke: '#aeaeae',
    strokeWidth: 1,
    opacity: 0,
    fillPatternImage: new Image(),
    fillPatternScale: { x: 1, y: 1 },
  };

  configText = {
    text: '',
    x: (this.configBg.width * 0.1) / 2,
    y: 50,
    width: this.configBg.width * 0.9,
    align: 'center',
    fill: '#333333',
    opacity: 0,
    fontSize: 26,
    fontFamily: 'Bilbo',
  };

  addImg(name: string): void {
    const img = new Image();
    img.onload = () => {
      this.configImage.fillPatternImage = img;
      const scale = this.configImage.width / img.width;
      this.configImage.fillPatternScale = {
        x: scale,
        y: scale,
      };
    };
    img.src = require(`../assets/images/${name}.jpg`);
  }

  addEvents(): void {
    window.addEventListener('resize', () => {
      this.configBg.width = Math.min(window.innerWidth * 0.8, 400);
      this.configEventPanel.x = window.innerWidth / 2 - this.configBg.width / 2;
    });
  }

  animateYonLoad(): void {
    const pos = { y: this.configEventPanel.y };

    gsap.to(pos, {
      y: window.innerHeight - this.configBg.height - 10,
      duration: 1,
      ease: 'power3.out',
      onUpdate: () => (this.configEventPanel.y = pos.y),
    });
  }

  mounted() {
    this.addEvents();
    setTimeout(this.animateYonLoad, 2000);
  }

  @Watch('currentEvent')
  onEventChange(newEvent: { title: string; id: string }) {
    const tl = gsap.timeline({
      defaults: { duration: 0.5, ease: 'power3.out' },
    });
    const opacity = { val: this.configText.opacity };
    tl.to(opacity, {
      val: 0,
      onUpdate: () => {
        this.configText.opacity = opacity.val;
        this.configImage.opacity = opacity.val;
      },
      onComplete: () => {
        this.configText.text = newEvent.title;
        this.addImg(newEvent.id);
      },
    });
    tl.to(
      opacity,
      {
        val: 1,
        onUpdate: () => {
          this.configText.opacity = opacity.val;
          this.configImage.opacity = opacity.val;
        },
      },
      '>0.1',
    );
  }

  @Watch('minimized')
  onMinimize() {
    const pos = { y: this.configEventPanel.y };
    gsap.to(pos, {
      y:
        pos.y === window.innerHeight - this.configImage.height - 10
          ? window.innerHeight - this.configBg.height - 10
          : window.innerHeight - this.configImage.height - 10,
      duration: 1,
      ease: 'power3.out',
      onUpdate: () => (this.configEventPanel.y = pos.y),
    });
  }
}
